export type IconProps = {
  view:
    | 'tool'
    | 'gear'
    | 'fist'
    | 'gift'
    | 'steam'
    | 'piechart'
    | 'shareprogress'
    | 'lightning'
    | 'key'
    | 'devices'
    | 'dollar'
    | 'game_library'
    | 'gamepad'
    | 'inventory'
    | 'playtime'
    | 'privacy_first'
    | 'profile_information'
    | 'profile'
    | 'privateInventory'
    | 'privateFriends'
    | 'privateGame'
    | 'privateDetails'
    | 'privatePerson'
    | 'trendingStreaks'
    | 'trendingWeb3'
    | 'roundedArrow'
    | 'checked'
    | 'steamColor'
    | 'throbber'
    | 'gamedTransparent'
    | 'loginInfo'
    | 'gamed'
    | 'trending'
    | 'dota2'
    | 'cs2'
    | 'copy'
    | 'arrowRight'
    | 'main'
    | 'social'
    | 'tasks'
    | 'leaders'
    | 'lock'
    | 'checkedWhite'
    | 'checkedGreen'
    | 'wallet'
    | 'stories'
    | 'gamedCoin'
    | 'git'
    | 'gamedKey'
    | 'plusLogo'
    | 'tgStar'
    | 'moreBoxes'
    | 'tggift'
    | 'joinCommunity'
    | 'paymentHistory'
    | 'thumbsUp'
    | 'thumbsDown'
    | 'alert'
    | 'transactionSuccessful'
    | 'transactionCanceled'
    | 'transactionProcessing'
    | 'transactionRefunded'
    | 'whitePlus'
    | 'greyLock'
    | 'whiteChecked'
    | 'whiteLock'
    | 'steamDeckNews'
    | 'farcana'
    | 'gigi'
    | 'helpSign'
    | 'gigiInfo'
    | 'premiumStar'
    | 'rocket'
    | 'share'
    | 'eye'
    | 'updating'
    | 'time'
    | 'progressUp'
    | 'progressDown'
    | 'gigiVector'
    | 'bluePremiumStar'
    | 'addFriend'
    | 'removeFriend'
    | 'privateEye'
    | 'platinum'
    | 'roundedPlusStar'
    | 'wink'
    | 'roundedPlatinumStar'
    | 'whiteAlert'
    | 'close'
    | 'hot'
    | 'transactionProcessing'
    | 'transactionSuccess'
    | 'telegram'
    | 'socialReferrals'
    | 'socialGigi'
    | 'socialFriends'
    | 'referralPlatinum'
    | 'referralPlus'
    | 'gamedUpdating'
    | 'friendNotAdded'
    | 'friendAdded'
    | 'leaderboardAssets'
    | 'leaderboardTime'
    | 'shopSales'
    | 'shopSupplies'
    | 'shopPrimary'
    | 'shop'
  invert?: boolean
  style?: React.CSSProperties
  width?: number
  animation?: string
}

export type TIconVariant = IconProps['view']

export function Icon({ view, invert = false, style = {}, width, animation }: IconProps) {
  return (
    <img
      src={'/assets/webp/icons/' + view + '.webp'}
      alt={view}
      style={{
        width: width ? `${width}px` : '24px',
        filter: invert ? 'invert(1)' : 'invert(0)',
        pointerEvents: 'none',
        animation: view === 'throbber' ? 'testing 1s steps(3, end) infinite' : animation,
        ...style,
      }}
    />
  )
}
